import { useCallback, useState } from "react";
import { CatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder";
import { MuiRightDrawer } from "../../../../components";
import CheckListSearch from "../../../../components/CheckListSearch";
import { APICallFunction, APIParams } from "../../role/apiCall";
import { addUserApplicationMapping, deleteUserApplicationMapping, getUserApplicationMapping, userNotInApplication } from "../apiCall";
import { UserKeys } from "../entity";

export const UserApplicationMapping = (props: any) => {
  const { request } = props;
  const [open, setOpen] = useState(false);

  const columns = [
    {
      field: "ApplicationName",
      headerName: "Application Name",
      editable: false,
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    }
  ];

  const onClose = (e: any) => {
    setOpen(false);
  }

  const onSubmit: APICallFunction = useCallback(async (params) => {
    const res: any = await addUserApplicationMapping({ ...params, request: { ...params.request, ...request } });
    return res;
  }, [request])

  const getOptions = useCallback(async (params: APIParams) => await userNotInApplication({ ...params, request: { ...params.request, ...request } }), [request])

  return (
    <>
      <CatalogBuilder
        isHeader={false}
        isRightMenu={true}
        isAssociationButton={true}

        getPagingData={getUserApplicationMapping}
        pagingAPIrequest={request}
        pagingAPIKey={UserKeys.getApplicationMapping}

        onDelete={deleteUserApplicationMapping}
        deletePagingAPIKey={UserKeys.deleteApplicationMapping}

        // pagingColumns={columns}
        visibleColumns={{
          IdentityName: false
        }}
        onClickPlus={() => { setOpen(true) }}
        disableEditAction={true}
        disableViewAction={true}
      />
      <MuiRightDrawer open={open} onClose={onClose} width={'40%'} >
        <CheckListSearch
          getOptions={getOptions}
          displayExpr={'DisplayName'}
          listKey={UserKeys.notInApplications}
          label='Add Applications'
          name='ApplicationId'
          onSubmit={onSubmit}
          onClose={onClose}
          pagingAPIKey={UserKeys.getApplicationMapping}
        />
      </MuiRightDrawer>
    </>
  );
};
